import api, { getAccessToken } from './api';
import qs from 'qs';

type UpdateUserType = {
  firstname:	string
  username:	string
  lastname:	string
  disabled:	boolean
  coverImageId:	string
  chatBlocked:	boolean
  coins:	number
  energy:	number
}

export const getAdminsList = async () => {
  await getAccessToken();
  
  const list = await api.get('auth/list-admins');
  
  return list.data;
};

export const getUsersList = async (props?: any) => {
  await getAccessToken();
  
  const list = await api.get(`users?${qs.stringify(props)}`);
  
  return list.data;
}

export const deleteUser = async (userId: string) => {
  await getAccessToken();
  
  const list = await api.deleteApi(`users/${userId}`);
  
  return list.data;
}

export const updateUser = async (user: any) => {
  const config: UpdateUserType = {
    firstname: user.firstname,
    username:	user.username,
    lastname:	user.lastname,
    disabled:	user.disabled,
    coverImageId:	user?.coverImage?.id ?? null,
    chatBlocked: user.chatBlocked,
    coins: user.coins,
    energy: user.energy
  }
  
  await api.put(`users/${user.id}`, { data: config });
}

export const removeAdminById = async ({ firebaseId }: { firebaseId: string }) => {
  await getAccessToken();
  
  const list = await api.deleteApi(`auth/delete-admin/${firebaseId}`);
  
  return list.data;
};